import { useSeekaConverge } from "@seeka-labs/converge-react";
import {
  Box,
  Flex,
  PrimaryButton,
  Radio,
  RadioGroup,
  Stack,
  Text,
} from "flicket-ui";
import { Select } from "~components";
import {
  AlcoholFreeZoneTypes,
  CoverTypes,
  SortTypes,
} from "~components/reservation/constants";
import { useReservationStore } from "~features/seated-reservation/store";
import * as actions from "~features/seated-reservation/store/actions/index";
import { useIsMobile } from "~hooks";

type OptionsProps = {
  handleClose: () => void;
  title?: string;
  startDate?: string;
  endDate?: string;
  location?: string;
  seatAmountOptions: any;
};

// eslint-disable-next-line react/prop-types
export const CoverType = ({ selectedType, changeCoverType }) => (
  <Stack flexDir="column" space={5} width="100%" mb={3}>
    <RadioGroup
      toggle
      value={selectedType}
      onChange={changeCoverType}
      space={5}
    >
      <Radio value={CoverTypes.ALL}>
        <Text>No preference</Text>
      </Radio>
      <Radio value={CoverTypes.COVERED}>
        <Text>Covered</Text>
      </Radio>
      <Radio value={CoverTypes.UNCOVERED}>
        <Text>Uncovered</Text>
      </Radio>
    </RadioGroup>
  </Stack>
);

// eslint-disable-next-line react/prop-types
export const AlcoholFreeZone = ({ alcoholFreeZone, changeAlcoholFreeZone }) => (
  <Stack flexDir="column" space={5} width="100%" mb={2}>
    <RadioGroup
      toggle
      value={alcoholFreeZone}
      onChange={changeAlcoholFreeZone}
      space={5}
    >
      <Radio value={AlcoholFreeZoneTypes.NO_PREFERENCE}>
        <Text whiteSpace="nowrap">No preference</Text>
      </Radio>
      <Radio value={AlcoholFreeZoneTypes.YES}>
        <Text>Yes</Text>
      </Radio>
      <Radio value={AlcoholFreeZoneTypes.NO}>
        <Text>No</Text>
      </Radio>
    </RadioGroup>
  </Stack>
);

// eslint-disable-next-line react/prop-types
export const SortBy = ({ selectedSort, changeSort }) => (
  <Stack flexDir="column" space={5} width="100%" mb={2}>
    <RadioGroup toggle value={selectedSort} onChange={changeSort} space={5}>
      <Radio value={SortTypes.BEST_AVAILABLE}>
        <Text>Best available</Text>
      </Radio>
      <Radio value={SortTypes.PRICE}>
        <Text>Price</Text>
      </Radio>
    </RadioGroup>
  </Stack>
);

export const Options = ({
  handleClose,
  title,
  startDate,
  endDate,
  location,
  seatAmountOptions,
}: OptionsProps) => {
  const converge = useSeekaConverge();
  const isMobile = useIsMobile();

  const chartReady = useReservationStore((state) => state.chartReady);
  const options = useReservationStore((state) => state.options);

  const updateOptions = async (key, value) =>
    actions.updateOptions({ options: { [key]: value } }, converge);

  return (
    <Flex flexDir="column" width="100%" p={{ _: 2, md: 0 }}>
      <Box>
        <Text fontWeight="extraBold" color="N800" fontSize={2} mb="6/4">
          I need tickets for
        </Text>
        <Select
          value={seatAmountOptions.find(
            (option) => option.value === options.amount
          )}
          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
          onChange={async ({ value }) => updateOptions("amount", value)}
          options={seatAmountOptions}
          mb={5}
          isDisabled={!chartReady}
          selectProps={{
            isSearchable: false,
            // 300 is the default max menu height
            // This fixes a bug on android Chrome
            // where the dropdown does off the bottom viewport
            maxMenuHeight: isMobile ? 150 : 300,
          }}
        />
      </Box>

      <PrimaryButton mt={3} mb={5} onClick={handleClose}>
        Select seat{options.amount > 1 ? "s" : ""}
      </PrimaryButton>
    </Flex>
  );
};
